import styled from 'styled-components';

export const StyleLogoTalenta = styled.div`
  .logo {
    margin-left: 10px;

    img {
      width: 140px;
      max-width: 100%;
    }
  }
`;
